var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 108,
    viewBox: "0 0 196 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31281_77456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.919 62.7016L4.54825 48.0179L6.01696 47.2572L4.40612 46.3947L2.57193 47.3455L1.46194 47.916L1.46871 47.9228L0 48.6835L1.60407 49.546L3.07955 48.7853L30.4503 63.4623L31.919 62.7016Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.481 52.031L25.1103 37.3541L26.579 36.5934L24.9681 35.7308L23.1339 36.6817L22.024 37.2454L22.0307 37.2522L20.562 38.0129L22.1661 38.8754L23.6416 38.1147L51.0123 52.7917L52.481 52.031Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0425 41.362L45.6718 26.6851L47.1405 25.9244L45.5297 25.0619L43.6955 26.0127L42.5855 26.5764L42.5922 26.5832L41.1235 27.3439L42.7276 28.2132L44.2031 27.4458L71.5738 42.1227L73.0425 41.362Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6044 30.6911L66.2337 16.0142L67.7024 15.2535L66.0915 14.391L64.2574 15.3418L63.1474 15.9123H63.1541L61.6854 16.6798L63.2895 17.5424L64.765 16.7749L92.1357 31.4586L93.6044 30.6911Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.167 20.0287L86.7963 5.34502L88.265 4.58435L86.6542 3.7218L84.82 4.67264L83.71 5.24315L83.7168 5.24994L82.248 6.01061L83.8521 6.87316L85.3276 6.1057L112.698 20.7894L114.167 20.0287Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1035 95.5189L94.5722 94.7514L92.9681 93.8889L91.4926 94.6563L57.6785 76.5156L56.2098 77.2763L90.0239 95.417L88.562 96.1777L90.1661 97.0402L92.0003 96.0894L93.1103 95.5189H93.1035Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5415 106.181L74.0102 105.421L72.4061 104.558L70.9306 105.319L37.1165 87.1848L35.6478 87.9455L69.4619 106.086L68 106.84L69.6041 107.709L71.4383 106.759L72.5415 106.181Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.665 84.8498L115.134 84.0823L113.53 83.2198L112.054 83.9873L78.2402 65.8466L76.7715 66.614L110.586 84.7479L109.124 85.5086L110.728 86.3711L112.562 85.4203L113.665 84.8498Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.228 74.1789L135.696 73.4182L134.092 72.5557L132.617 73.3164L98.7958 55.1757L97.3339 55.9363L131.148 74.077L129.679 74.8377L131.29 75.7003L133.124 74.7494L134.228 74.1789Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.789 63.5102L156.258 62.7496L154.654 61.887L153.178 62.6477L119.357 44.5138L117.889 45.2745L151.71 63.4152L150.241 64.169L151.852 65.0384L153.686 64.0875L154.789 63.5102Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.351 52.8461L176.82 52.0787L175.216 51.2161L173.74 51.9836L139.919 33.8429L138.451 34.6036L172.271 52.7443L170.803 53.5049L172.414 54.3675L174.248 53.4166L175.351 52.8461Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.913 42.1767L194.302 41.3141L160.488 23.1666L159.019 23.9273L192.833 42.0748L191.365 42.8355L192.976 43.698L194.81 42.7472L195.913 42.1767Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23815 83.1573L8.66962 76.6576L27.9929 87.0218L28.5547 93.5214L9.23815 83.1573Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.045 15.3762L27.9935 87.0221L28.5553 93.5218L166.614 21.8827L173.957 18.0725L173.389 11.566L166.045 15.3762Z",
    fill: "#178477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.388 11.5653L154.065 1.20789L8.66962 76.6572L27.9929 87.0213L173.388 11.5653Z",
    fill: "#178477",
    fillOpacity: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.287 2.93298L155.588 2.02289L154.065 1.20789L148.184 4.25737L147.926 4.38641L146.715 5.01804L136.935 10.0915L130.309 13.5281L127.622 14.9204L126.153 15.6811L119.344 19.2127L112.691 22.6629L107.06 25.5834L105.591 26.3441L101.754 28.334L95.0801 31.7978L86.5048 36.2464L85.036 37.0071L84.1629 37.4621L77.4624 40.9395L66.5723 46.5902L65.9429 46.9162L64.4741 47.6769L59.8514 50.0744L48.9817 55.7115L42.2337 59.2092L31.3842 64.8396L24.616 68.3509L8.66327 76.63L27.9866 86.9942L173.389 11.5653L157.287 2.93298ZM14.8291 76.8609L26.5856 70.7619L32.9409 67.4612L44.1694 61.6339L50.5587 58.3195L61.7533 52.5058L68.1764 49.1711L79.344 43.3777L85.8009 40.0294L96.9346 34.2496L103.419 30.8809L114.518 25.1216L121.036 21.7393L132.109 15.9935L138.654 12.5976L149.7 6.86539L154.356 4.44754L156.211 5.43913L167.236 11.3547L27.7091 83.7681L14.8291 76.8609Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2578 70.2802L28.7384 75.7747C28.7519 75.897 29.0632 76.0124 29.4423 76.0192C29.8213 76.026 30.1123 75.9377 30.1055 75.8155L29.625 70.321L28.2578 70.2734V70.2802Z",
    fill: "url(#paint0_linear_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6782 69.4803C33.5649 67.5859 32.5038 65.2111 30.308 64.1761C28.1122 63.1412 25.6133 63.8379 24.7265 65.7324C23.8397 67.6268 24.9009 70.0016 27.0967 71.0366C29.2925 72.0715 31.7914 71.3748 32.6782 69.4803Z",
    fill: "url(#paint1_radial_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8816 61.1781L46.3621 66.6726C46.3757 66.7948 46.687 66.9103 47.066 66.9171C47.4451 66.9239 47.7361 66.8356 47.7293 66.7133L47.2488 61.2188L45.8816 61.1713V61.1781Z",
    fill: "url(#paint2_linear_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3033 60.3883C51.1901 58.4938 50.1289 56.1191 47.9331 55.0841C45.7373 54.0491 43.2384 54.7459 42.3516 56.6403C41.4648 58.5348 42.526 60.9096 44.7218 61.9445C46.9176 62.9795 49.4165 62.2827 50.3033 60.3883Z",
    fill: "url(#paint3_radial_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5144 52.085L63.995 57.5795C64.0085 57.7018 64.3198 57.8173 64.6988 57.824C65.0779 57.8308 65.3689 57.7425 65.3621 57.6203L64.8816 52.1258L63.5144 52.0782V52.085Z",
    fill: "url(#paint4_linear_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9396 51.286C68.8264 49.3915 67.7652 47.0168 65.5694 45.9818C63.3737 44.9468 60.8747 45.6436 59.988 47.538C59.1012 49.4325 60.1624 51.8073 62.3582 52.8422C64.554 53.8772 67.0529 53.1805 67.9396 51.286Z",
    fill: "url(#paint5_radial_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1388 42.9842L81.6193 48.4787C81.6329 48.601 81.9442 48.7164 82.3232 48.7232C82.7023 48.73 82.9933 48.6417 82.9865 48.5195L82.506 43.025L81.1388 42.9774V42.9842Z",
    fill: "url(#paint6_linear_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5652 42.1889C86.452 40.2945 85.3909 37.9197 83.1951 36.8847C80.9993 35.8498 78.5004 36.5465 77.6136 38.441C76.7268 40.3355 77.788 42.7102 79.9838 43.7452C82.1796 44.7802 84.6785 44.0834 85.5652 42.1889Z",
    fill: "url(#paint7_radial_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.77 33.8837L99.2506 39.3783C99.2641 39.5005 99.5754 39.616 99.9545 39.6228C100.333 39.6295 100.625 39.5413 100.618 39.419L100.137 33.9245L98.77 33.877V33.8837Z",
    fill: "url(#paint8_linear_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.194 33.0847C104.081 31.1902 103.02 28.8155 100.824 27.7805C98.6284 26.7455 96.1295 27.4423 95.2427 29.3367C94.356 31.2312 95.4171 33.606 97.6129 34.6409C99.8087 35.6759 102.308 34.9792 103.194 33.0847Z",
    fill: "url(#paint9_radial_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.394 24.7827L116.874 30.2772C116.888 30.3994 117.199 30.5149 117.578 30.5217C117.957 30.5285 118.248 30.4402 118.242 30.3179L117.761 24.8234L116.394 24.7759V24.7827Z",
    fill: "url(#paint10_linear_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.827 23.9927C121.714 22.0982 120.652 19.7234 118.457 18.6885C116.261 17.6535 113.762 18.3502 112.875 20.2447C111.988 22.1392 113.049 24.5139 115.245 25.5489C117.441 26.5839 119.94 25.8871 120.827 23.9927Z",
    fill: "url(#paint11_radial_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.025 15.6823L134.506 21.1768C134.519 21.2991 134.831 21.4145 135.21 21.4213C135.589 21.4281 135.88 21.3398 135.873 21.2176L135.393 15.7231L134.025 15.6755V15.6823Z",
    fill: "url(#paint12_linear_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.456 14.8878C139.342 12.9933 138.281 10.6186 136.085 9.5836C133.89 8.54864 131.391 9.24539 130.504 11.1399C129.617 13.0343 130.678 15.4091 132.874 16.444C135.07 17.479 137.569 16.7823 138.456 14.8878Z",
    fill: "url(#paint13_radial_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.649 6.58724L152.129 12.0817C152.143 12.204 152.454 12.3195 152.833 12.3262C153.212 12.333 153.503 12.2447 153.496 12.1225L153.016 6.62799L151.649 6.58044V6.58724Z",
    fill: "url(#paint14_linear_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.087 5.79197C156.974 3.89751 155.913 1.52274 153.717 0.487772C151.521 -0.547198 149.022 0.149558 148.135 2.04402C147.249 3.93848 148.31 6.31325 150.506 7.34822C152.701 8.38319 155.2 7.68643 156.087 5.79197Z",
    fill: "url(#paint15_radial_31281_77456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8914 32.9461C71.0877 32.919 71.3314 32.9665 71.6021 33.1091C72.3263 33.4963 72.9625 34.4064 73.0302 35.1331C73.0437 35.3164 73.0302 35.4659 72.9693 35.5881C72.7594 36.0907 71.7848 36.3827 71.7848 36.3827L69.7137 33.6049C70.1266 33.0684 70.8237 32.9461 70.8914 32.9393V32.9461Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7627 33.5987C71.4869 33.9858 72.1231 34.8959 72.1908 35.6226C72.2584 36.3494 71.717 36.6278 70.9928 36.2407C70.2686 35.8536 69.6324 34.9435 69.5647 34.2168C69.497 33.49 70.0385 33.2116 70.7627 33.5987Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8242 34.2578C71.1829 34.4479 71.5078 34.9098 71.5349 35.2697C71.5619 35.6297 71.298 35.7723 70.9393 35.5821C70.5805 35.392 70.2557 34.9301 70.2286 34.5702C70.2015 34.2102 70.4655 34.0676 70.8242 34.2578Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7501 26.977C59.9463 26.9499 60.19 26.9974 60.4607 27.14C61.1849 27.5271 61.8211 28.4372 61.8888 29.164C61.9024 29.3473 61.8888 29.4967 61.8279 29.619C61.6181 30.1216 60.6435 30.4136 60.6435 30.4136L58.5724 27.6358C58.9853 27.0993 59.6824 26.977 59.7501 26.9702V26.977Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6213 27.6363C60.3455 28.0234 60.9817 28.9335 61.0494 29.6602C61.1171 30.387 60.5756 30.6654 59.8514 30.2783C59.1272 29.8912 58.491 28.9811 58.4233 28.2544C58.3556 27.5276 58.8971 27.2492 59.6213 27.6363Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6827 28.2951C60.0414 28.4853 60.3663 28.9471 60.3934 29.3071C60.4205 29.667 60.1565 29.8097 59.7978 29.6195C59.4391 29.4293 59.1142 28.9675 59.0871 28.6075C59.06 28.2476 59.324 28.1049 59.6827 28.2951Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0111 26.3787L64.0551 21.1694L71.9604 25.3667L73.8014 32.7086L74.1466 36.6817L73.9909 36.6002L70.6948 34.8344L70.2142 34.5763L61.3749 29.8357C61.3749 29.7813 61.3749 29.7338 61.3749 29.6795C61.3005 28.8373 60.5898 27.8321 59.7641 27.3839C59.5069 27.248 59.2565 27.1733 59.0263 27.1665C58.4713 27.1462 58.1126 27.5061 58.0923 28.0698L55.8046 26.8473L55.4595 22.8674L62.0111 26.3923V26.3787Z",
    fill: "#E2AF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9669 25.3666L81.4898 20.4222L83.3714 27.7437L73.8079 32.7085L71.9669 25.3666Z",
    fill: "#F9CC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0264 27.5874L81.2938 20.8704L72.3191 25.5227L74.0112 32.2669L83.0264 27.5874Z",
    fill: "#806061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.49 20.4226L73.6253 16.205L64.0618 21.1697L71.9671 25.367L81.49 20.4226Z",
    fill: "#FCD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4595 22.8604L65.023 17.9025L67.6491 19.3084L64.0619 21.1693L62.0111 26.3785L55.4595 22.8604Z",
    fill: "#F7C961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7316 23.9606L71.7028 25.5363L73.4016 32.3144L73.449 32.5181L69.2798 30.2769L68.7316 23.9606Z",
    fill: "#725457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2791 25.2389L57.3062 25.5038L56.7782 25.2253L56.7579 24.9604L57.2791 25.2389Z",
    fill: "#EA9632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2795 25.2382L57.4013 25.1771L56.8801 24.8918L56.7583 24.9598L57.2795 25.2382Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3058 25.5031L57.4212 25.4418L57.4008 25.1763L57.2787 25.2376L57.3058 25.5031Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2443 21.5767L67.6961 23.4104L68.3661 23.7636L68.9144 30.0799L68.2443 29.7267L67.757 29.4619L63.5471 27.2002L63.2697 24.0488L64.2443 21.5767Z",
    fill: "#725457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0022 26.2167L57.1172 27.5411L56.5148 27.8535L56.3998 26.5291L57.0022 26.2167Z",
    fill: "#F9CC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4371 25.4758L54.5522 26.7934L56.515 27.8529L56.3999 26.5285L54.4371 25.4758Z",
    fill: "#E2AF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0023 26.2152L56.3999 26.5277L54.4371 25.4749L55.6351 24.8501L55.6893 25.5157L57.0023 26.2152Z",
    fill: "#FCD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9486 30.4609L68.9824 30.848L67.8454 30.2368L67.8115 29.8564L68.9486 30.4609Z",
    fill: "#A86D16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3715 27.743L83.7234 31.7162L74.1532 36.681L73.808 32.7078L83.3715 27.743Z",
    fill: "#F9CC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.217 32.6241L76.2914 33.4459L75.1747 34.0232L75.1002 33.2014L76.217 32.6241Z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7688 33.8058L74.6943 32.984L75.1004 33.2013L75.1749 34.0231L74.7688 33.8058Z",
    fill: "#A81D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2172 32.6237L75.8111 32.4064L74.6943 32.9837L75.1004 33.201L76.2172 32.6237Z",
    fill: "#C92D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.412 33.0404L75.4865 33.8622L75.1752 34.0252L75.1007 33.2034L75.412 33.0404Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4118 33.0401L75.0057 32.8228L74.6943 32.9858L75.1004 33.2031L75.4118 33.0401Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1004 33.2034L74.6943 32.9861L74.7688 33.8079L75.1749 34.0252L75.1004 33.2034Z",
    fill: "#EA9632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0195 29.0947L83.0939 29.9165L81.9772 30.5006L81.9027 29.6788L83.0195 29.0947Z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5713 30.2833L81.4968 29.4547L81.9029 29.6788L81.9774 30.5006L81.5713 30.2833Z",
    fill: "#A81D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0196 29.0947L82.6135 28.8773L81.4967 29.4546L81.9028 29.6787L83.0196 29.0947Z",
    fill: "#C92D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0195 29.095L83.0939 29.9168L82.7826 30.0798L82.7081 29.258L83.0195 29.095Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0197 29.0948L82.6136 28.8774L82.3022 29.0404L82.7083 29.2578L83.0197 29.0948Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2699 24.0496L62.2682 26.515L63.5474 27.2009L63.2699 24.0496Z",
    fill: "#A86D16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1732 26.23L62.9245 26.4337C62.999 26.4541 63.0599 26.4065 63.0599 26.3386C63.0599 26.2911 63.0193 26.2503 62.9719 26.2368L62.2748 26.0398L62.004 26.0805L62.18 26.2368L62.1732 26.23Z",
    fill: "#FCD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0499 26.1826C61.0161 25.8158 61.2597 25.3811 61.5914 25.2114C61.7267 25.1366 61.8621 25.1231 61.9704 25.1638C62.0854 25.191 62.187 25.2861 62.187 25.2861H62.1463C62.2005 25.3608 62.2343 25.4559 62.2479 25.5645C62.2817 25.9313 62.0381 26.3659 61.7064 26.5357C61.6049 26.5901 61.5101 26.6104 61.4221 26.6037V26.6444C61.4221 26.6444 61.2665 26.5833 61.2056 26.5222C61.1176 26.4474 61.0634 26.3388 61.0499 26.1894V26.1826Z",
    fill: "#A86D16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3423 25.6193C62.3085 25.2526 62.0174 25.0964 61.6858 25.2662C61.3541 25.4359 61.1172 25.8774 61.1443 26.2374C61.1714 26.5973 61.4692 26.7603 61.8008 26.5905C62.1325 26.4207 62.3761 25.9793 62.3423 25.6193Z",
    fill: "#FCD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5235 26.5976C61.598 26.5976 61.6792 26.5772 61.7604 26.5364C62.065 26.3802 62.3019 25.9524 62.2748 25.6128C62.2545 25.3954 62.1394 25.2596 61.9635 25.2528C61.889 25.2528 61.8078 25.2732 61.7266 25.3139C61.422 25.4701 61.1851 25.898 61.2122 26.2376C61.2325 26.4549 61.3476 26.5908 61.5235 26.5976Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0991 36.017L74.2142 37.3414L84.9757 31.7586L84.8606 30.4342L74.0991 36.017Z",
    fill: "#F9CC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8603 30.434L83.5473 29.7277L83.6014 30.3932L74.0379 35.358L73.3814 35.0048L72.7858 35.3173L74.0988 36.0168L84.8603 30.434Z",
    fill: "#FCD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7859 35.3173L72.9009 36.6349L74.214 37.3412L74.0989 36.0168L72.7859 35.3173Z",
    fill: "#E2AF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2818 31.7784L63.2023 42.3667L53.632 47.3315L52.7115 36.7432L62.2818 31.7784Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9133 42.2838C48.1095 42.2566 48.3532 42.3042 48.6239 42.4468C49.3481 42.8339 49.9843 43.744 50.052 44.4707C50.0656 44.6541 50.052 44.8035 49.9911 44.9258C49.7813 45.4284 48.8067 45.7204 48.8067 45.7204L46.7356 42.9426C47.1485 42.406 47.8456 42.2838 47.9133 42.277V42.2838Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7846 42.9364C48.5088 43.3235 49.145 44.2336 49.2127 44.9603C49.2804 45.687 48.7389 45.9655 48.0147 45.5783C47.2905 45.1912 46.6543 44.2811 46.5866 43.5544C46.519 42.8277 47.0604 42.5492 47.7846 42.9364Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8458 43.5954C48.2045 43.7856 48.5294 44.2474 48.5565 44.6074C48.5835 44.9673 48.3196 45.11 47.9609 44.9198C47.6022 44.7296 47.2773 44.2678 47.2502 43.9078C47.2231 43.5479 47.4871 43.4052 47.8458 43.5954Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2972 35.5271C35.4935 35.4999 35.7371 35.5474 36.0078 35.6901C36.732 36.0772 37.3683 36.9873 37.4359 37.714C37.4495 37.8974 37.4359 38.0468 37.375 38.169C37.1652 38.6716 36.1906 38.9637 36.1906 38.9637L34.1195 36.1859C34.5324 35.6493 35.2295 35.5271 35.2972 35.5203V35.5271Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1678 36.1793C35.892 36.5664 36.5282 37.4765 36.5959 38.2032C36.6636 38.9299 36.1221 39.2084 35.3979 38.8213C34.6737 38.4341 34.0375 37.524 33.9698 36.7973C33.9021 36.0706 34.4436 35.7922 35.1678 36.1793Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2292 36.8381C35.5879 37.0282 35.9128 37.4901 35.9399 37.85C35.967 38.21 35.703 38.3526 35.3443 38.1625C34.9856 37.9723 34.6607 37.5105 34.6336 37.1505C34.6065 36.7905 34.8705 36.6479 35.2292 36.8381Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5646 34.9229L39.6086 29.7136L52.7186 36.7431L53.6391 47.3314L49.5511 45.1376C49.5511 45.0833 49.5511 45.029 49.5511 44.9746C49.4767 44.1325 48.766 43.1273 47.9403 42.679C47.6831 42.5432 47.4326 42.4685 47.2025 42.4617C46.6408 42.4413 46.282 42.8013 46.2685 43.3718L36.9486 38.3731C36.9486 38.3187 36.9486 38.2712 36.9486 38.2169C36.8742 37.3747 36.1635 36.3695 35.3378 35.9213C35.0806 35.7854 34.8302 35.7107 34.6001 35.7039C34.0451 35.6835 33.6864 36.0435 33.666 36.6072L31.3784 35.3779L31.0332 31.398L37.5849 34.9229H37.5646Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.006 31.4046L40.5695 26.4467L43.1956 27.8525L39.6084 29.7135L37.5644 34.9227L31.006 31.4046Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5782 46.6733L53.6933 47.9909L64.4548 42.4081L64.3397 41.0837L53.5782 46.6733Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3394 41.0833L63.0264 40.3838L63.0873 41.0426L53.517 46.0073L52.8673 45.6542L52.2649 45.9666L53.5779 46.6729L64.3394 41.0833Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2649 45.9658L52.38 47.2902L53.693 47.9898L53.5779 46.6722L52.2649 45.9658Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8326 33.784L32.8529 34.0488L32.3318 33.7704L32.3047 33.5055L32.8326 33.784Z",
    fill: "#EA9632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8326 33.7829L32.9477 33.7218L32.4265 33.4365L32.3047 33.5044L32.8326 33.7829Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8536 34.048L32.9758 33.9868L32.9486 33.7212L32.8333 33.7825L32.8536 34.048Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7908 30.1208L43.2426 31.9546L43.9126 32.3078L44.4609 38.6241L43.7908 38.2709L43.3035 38.006L39.0937 35.7444L38.8162 32.593L39.7908 30.1208Z",
    fill: "#725457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5487 34.7609L32.6638 36.0853L32.0682 36.3977L31.9531 35.0733L32.5487 34.7609Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9838 34.02L30.0988 35.3376L32.0684 36.3971L31.9533 35.0727L29.9838 34.02Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5489 34.7594L31.9533 35.0718L29.9838 34.0191L31.1817 33.3943L31.2359 34.0599L32.5489 34.7594Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4952 39.0119L44.5291 39.3922L43.392 38.781L43.3582 38.4006L44.4952 39.0119Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6957 43.2782L55.7702 44.1068L54.6534 44.6841L54.579 43.8623L55.6957 43.2782Z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2475 44.4669L54.1731 43.6383L54.5792 43.8624L54.6536 44.6842L54.2475 44.4669Z",
    fill: "#A81D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6962 43.2779L55.2901 43.0605L54.1733 43.6378L54.5794 43.862L55.6962 43.2779Z",
    fill: "#C92D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8908 43.698L54.9653 44.5198L54.6539 44.6828L54.5795 43.861L54.8908 43.698Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.891 43.6979L54.4849 43.4806L54.1736 43.6368L54.5797 43.8609L54.891 43.6979Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5789 43.8606L54.1729 43.6365L54.2473 44.4651L54.6534 44.6824L54.5789 43.8606Z",
    fill: "#EA9632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4986 39.7534L62.573 40.5752L61.4563 41.1525L61.3818 40.3307L62.4986 39.7534Z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0502 40.9351L60.9757 40.1133L61.3818 40.3306L61.4563 41.1524L61.0502 40.9351Z",
    fill: "#A81D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4986 39.753L62.0925 39.5356L60.9757 40.1129L61.3818 40.3303L62.4986 39.753Z",
    fill: "#C92D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4982 39.7531L62.5727 40.5749L62.2613 40.7379L62.1869 39.9161L62.4982 39.7531Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4984 39.7526L62.0923 39.5353L61.781 39.6915L62.1871 39.9156L62.4984 39.7526Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.816 32.5936L37.821 35.059L39.0935 35.745L38.816 32.5936Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7202 34.7731L38.4715 34.9768C38.546 34.9972 38.6069 34.9496 38.6069 34.8817C38.6069 34.8342 38.5663 34.7934 38.5189 34.7798L37.8218 34.5829L37.551 34.6236L37.727 34.7798L37.7202 34.7731Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5969 34.7257C36.563 34.3589 36.8067 33.9242 37.1383 33.7544C37.2737 33.6797 37.4091 33.6662 37.5174 33.7069C37.6324 33.7341 37.734 33.8292 37.734 33.8292H37.6933C37.7475 33.9039 37.7813 33.9989 37.7949 34.1076C37.8287 34.4744 37.5851 34.909 37.2534 35.0788C37.1519 35.1332 37.0571 35.1535 36.9691 35.1467V35.1875C36.9691 35.1875 36.8135 35.1264 36.7526 35.0652C36.6646 34.9905 36.6104 34.8819 36.5969 34.7325V34.7257Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8898 34.1623C37.856 33.7955 37.565 33.6393 37.2333 33.8091C36.9017 33.9789 36.658 34.4204 36.6919 34.7803C36.7257 35.1403 37.0167 35.3033 37.3484 35.1335C37.68 34.9637 37.9169 34.5223 37.8898 34.1623Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0707 35.1407C37.1451 35.1407 37.2263 35.1203 37.3075 35.0795C37.6121 34.9233 37.849 34.4954 37.8219 34.1559C37.8016 33.9385 37.6866 33.8027 37.5106 33.7959C37.4361 33.7959 37.3549 33.8163 37.2737 33.857C36.9691 34.0132 36.7322 34.4411 36.7593 34.7807C36.7796 34.998 36.8947 35.1339 37.0707 35.1407Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2822 31.7786L49.1722 24.7491L39.6086 29.7139L52.7119 36.7433L62.2822 31.7786Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.128 52.8728C27.3243 52.8456 27.5679 52.8931 27.8387 53.0358C28.5629 53.4229 29.1991 54.333 29.2668 55.0597C29.2803 55.2431 29.2668 55.3925 29.2058 55.5148C28.996 56.0173 28.0214 56.3094 28.0214 56.3094L25.9503 53.5316C26.3632 52.995 27.0603 52.8728 27.128 52.866V52.8728Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9929 53.5244C27.7171 53.9115 28.3533 54.8216 28.421 55.5483C28.4887 56.275 27.9472 56.5535 27.223 56.1664C26.4988 55.7792 25.8626 54.8691 25.7949 54.1424C25.7272 53.4157 26.2687 53.1372 26.9929 53.5244Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0544 54.1829C27.4131 54.3731 27.738 54.8349 27.7651 55.1949C27.7922 55.5549 27.5282 55.6975 27.1695 55.5073C26.8108 55.3171 26.4859 54.8553 26.4588 54.4953C26.4317 54.1354 26.6957 53.9928 27.0544 54.1829Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5118 46.1226C14.7081 46.0955 14.9517 46.143 15.2224 46.2856C15.9466 46.6728 16.5829 47.5829 16.6505 48.3096C16.6641 48.493 16.6505 48.6424 16.5896 48.7646C16.3798 49.2672 15.4052 49.5593 15.4052 49.5593L13.3341 46.7814C13.747 46.2449 14.4441 46.1226 14.5118 46.1159V46.1226Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3831 46.7757C15.1073 47.1628 15.7436 48.0729 15.8112 48.7996C15.8789 49.5264 15.3375 49.8048 14.6133 49.4177C13.8891 49.0306 13.2528 48.1205 13.1852 47.3938C13.1175 46.667 13.6589 46.3886 14.3831 46.7757Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4374 47.4407C14.7961 47.6309 15.1209 48.0927 15.148 48.4527C15.1751 48.8127 14.9111 48.9553 14.5524 48.7651C14.1937 48.575 13.8688 48.1131 13.8418 47.7532C13.8147 47.3932 14.0786 47.2506 14.4374 47.4407Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.383 42.0934L9.80768 35.4783L15.0531 38.29L22.9178 42.5077L26.1124 50.5287L32.664 54.0468L33.0092 58.02L28.7587 55.738C28.7587 55.6837 28.7587 55.6293 28.7587 55.5682C28.6843 54.726 27.9736 53.7208 27.1479 53.2726C26.8907 53.1368 26.6403 53.062 26.4102 53.0553C25.8484 53.0349 25.4897 53.4016 25.4761 53.9721L16.1563 48.9734C16.1563 48.9191 16.1563 48.8648 16.1563 48.8104C16.0818 47.9683 15.3712 46.9631 14.5454 46.5148C14.2883 46.379 14.0378 46.3043 13.8077 46.2975C13.2459 46.2771 12.8872 46.6371 12.8737 47.2076L10.7485 46.0666L10.4033 42.0934H10.383Z",
    fill: "#E06B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8499 43.2487C34.8161 42.882 35.0598 42.4473 35.3914 42.2775C35.5268 42.2028 35.6621 42.1892 35.7704 42.23C35.8855 42.2571 35.987 42.3522 35.987 42.3522H35.9464C36.0005 42.4269 36.0344 42.522 36.0479 42.6307C36.0818 42.9974 35.8381 43.4321 35.5065 43.6019C35.4049 43.6562 35.3102 43.6766 35.2222 43.6698V43.7106C35.2222 43.7106 35.0665 43.6494 35.0056 43.5883C34.9176 43.5136 34.8635 43.4049 34.8499 43.2555V43.2487Z",
    fill: "#C44845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8639 44.1937L35.1481 43.6775C35.0398 43.6096 34.9654 43.4873 34.9451 43.3107C34.9112 42.944 35.1549 42.5093 35.4865 42.3395C35.8182 42.1697 36.1092 42.3259 36.1431 42.6927C36.1769 43.0594 35.9333 43.4941 35.6016 43.6639C35.5339 43.6979 35.4662 43.7182 35.3986 43.7318L35.0669 44.3091C35.0331 44.3634 34.9451 44.3702 34.8909 44.3227C34.8503 44.2887 34.8436 44.2412 34.8639 44.2004V44.1937Z",
    fill: "#FF978B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 54.0473L42.2277 49.0825L42.5729 53.0557L33.0094 58.0136L32.6642 54.0473Z",
    fill: "#F37A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6756 45.5715L26.1121 50.5295L32.6637 54.0476L42.2272 49.0829L35.6756 45.5715Z",
    fill: "#F7887F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6755 45.5718L32.4809 37.5439L22.9106 42.5087L26.112 50.5297L35.6755 45.5718Z",
    fill: "#F37A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2968 45.422L32.3255 37.9647L23.2899 42.6578L26.2612 50.1151L35.2968 45.422Z",
    fill: "#806061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6675 40.5662L22.6472 42.6988L23.4865 44.7974L23.7978 45.5785L24.5897 47.5616L24.786 49.8233L23.0398 48.886L19.2089 46.8281L18.6675 40.5662Z",
    fill: "#725457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9534 51.6497L40.0684 52.9672L35.2833 55.453L35.1682 54.1286L39.9534 51.6497Z",
    fill: "#C44845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8244 53.0973L33.0629 58.6801L32.9479 57.3557L43.7094 51.7729L43.8244 53.0973Z",
    fill: "#F37A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0631 58.6793L31.1003 57.6266L30.9852 56.3022L32.948 57.355L33.0631 58.6793Z",
    fill: "#E06B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7095 51.773L42.4032 51.0667L42.4574 51.7322L32.8939 56.697L31.5808 55.9907L30.9852 56.3031L32.948 57.3558L43.7095 51.773Z",
    fill: "#FF978B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3373 54.7277L31.3644 54.9926L30.8365 54.7141L30.8162 54.4492L31.3373 54.7277Z",
    fill: "#EA9632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3373 54.7268L31.4591 54.6656L30.938 54.3804L30.8162 54.4483L31.3373 54.7268Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3645 54.9919L31.4799 54.9306L31.4596 54.665L31.3374 54.7263L31.3645 54.9919Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0685 52.9678L39.791 52.8252L35.2631 55.1751L35.2834 55.4536L40.0685 52.9678Z",
    fill: "#E06B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7915 52.824L39.6968 51.7781L39.954 51.649L40.069 52.9666L39.7915 52.824Z",
    fill: "#F7887F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36133 44.7014L9.47639 46.0258L10.7827 46.7254L10.6676 45.401L9.36133 44.7014Z",
    fill: "#E06B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7825 46.7266L11.3849 46.4209L11.2699 45.0966L10.6675 45.4022L10.7825 46.7266Z",
    fill: "#F37A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36133 44.7019L10.5525 44.0839L10.6135 44.7427L11.27 45.0958L10.6676 45.4015L9.36133 44.7019Z",
    fill: "#FF978B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3797 47.8259L20.4136 48.2062L19.2765 47.5949L19.2427 47.2146L20.3797 47.8259Z",
    fill: "#C44845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2055 54.965C33.1717 54.5983 33.4153 54.1636 33.747 53.9938C33.8824 53.9191 34.0177 53.9055 34.126 53.9463C34.2411 53.9802 34.4103 54.0957 34.4103 54.0957L34.3358 54.1161C34.3697 54.1772 34.3967 54.2519 34.4035 54.3402C34.4374 54.707 34.1937 55.1416 33.862 55.3114C33.7741 55.359 33.6928 55.3793 33.6116 55.3793L33.6455 55.4269L33.6319 55.4473C33.6319 55.4473 33.4289 55.3725 33.3477 55.2843C33.2664 55.2095 33.2191 55.1009 33.2055 54.9582V54.965Z",
    fill: "#ADA1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9165 54.0893C34.2482 53.9195 34.5392 54.0757 34.5731 54.4424C34.6069 54.8092 34.3632 55.2439 34.0316 55.4137C33.7 55.5834 33.4089 55.4272 33.3751 55.0605C33.3412 54.6937 33.5849 54.2591 33.9165 54.0893Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9437 54.3809C34.1265 54.2858 34.2889 54.3741 34.3092 54.5779C34.3295 54.7816 34.1942 55.0193 34.0114 55.1144C33.8287 55.2095 33.6662 55.1212 33.6459 54.9175C33.6256 54.7137 33.761 54.476 33.9437 54.3809Z",
    fill: "#C8CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5157 51.1684C40.4819 50.8017 40.7255 50.367 41.0572 50.1972C41.1925 50.1225 41.3279 50.1089 41.4362 50.1496C41.5513 50.1836 41.7205 50.2991 41.7205 50.2991L41.646 50.3194C41.6798 50.3806 41.7069 50.4553 41.7137 50.5436C41.7475 50.9103 41.5039 51.345 41.1722 51.5148C41.0842 51.5623 41.003 51.5827 40.9218 51.5827L40.9556 51.6302L40.9421 51.6506C40.9421 51.6506 40.7391 51.5759 40.6578 51.4876C40.5766 51.4129 40.5292 51.3042 40.5157 51.1616V51.1684Z",
    fill: "#ADA1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2338 50.2926C41.5655 50.1228 41.8565 50.2791 41.8903 50.6458C41.9242 51.0126 41.6805 51.4472 41.3489 51.617C41.0172 51.7868 40.7262 51.6306 40.6923 51.2639C40.6585 50.8971 40.9022 50.4624 41.2338 50.2926Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2538 50.5916C41.4365 50.4965 41.599 50.5848 41.6193 50.7886C41.6396 50.9923 41.5042 51.23 41.3215 51.3251C41.1387 51.4202 40.9763 51.3319 40.956 51.1281C40.9357 50.9244 41.0711 50.6867 41.2538 50.5916Z",
    fill: "#C8CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6793 50.299L24.7859 49.8235L24.5896 47.5619L25.6793 50.299Z",
    fill: "#C44845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1816 49.5183C23.1478 49.1515 23.3914 48.7168 23.7231 48.547C23.8584 48.4723 23.9938 48.4588 24.1021 48.4995C24.2171 48.5267 24.3187 48.6218 24.3187 48.6218H24.2781C24.3322 48.6965 24.366 48.7915 24.3796 48.9002C24.4134 49.267 24.1698 49.7016 23.8381 49.8714C23.7366 49.9258 23.6418 49.9461 23.5539 49.9393V49.9801C23.5539 49.9801 23.3982 49.919 23.3373 49.8578C23.2493 49.7831 23.1951 49.6745 23.1816 49.5251V49.5183Z",
    fill: "#C44845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8183 48.602C24.1499 48.4322 24.441 48.5884 24.4748 48.9551C24.4883 49.091 24.4613 49.2404 24.4071 49.3762L25.1042 49.5732C25.1516 49.5868 25.1922 49.6275 25.1922 49.6751C25.1922 49.743 25.1313 49.7905 25.0569 49.7701L24.3056 49.5664C24.2108 49.7158 24.0822 49.8449 23.9333 49.9196C23.6017 50.0894 23.3107 49.9331 23.2768 49.5664C23.243 49.1996 23.4866 48.765 23.8183 48.5952V48.602Z",
    fill: "#FF978B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80768 35.4793L19.3712 30.5145L24.6166 33.3263L32.4813 37.544L22.911 42.5087L15.0463 38.2911L9.80768 35.4793Z",
    fill: "#FF978B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.996 66.6063C129.192 66.5791 129.436 66.6267 129.707 66.7693C130.431 67.1564 131.067 68.0665 131.135 68.7932C131.148 68.9766 131.135 69.126 131.074 69.2483C130.864 69.7509 129.889 70.0429 129.889 70.0429L127.818 67.2651C128.231 66.7285 128.928 66.6063 128.996 66.5995V66.6063Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.867 67.2586C129.591 67.6458 130.227 68.5558 130.295 69.2826C130.363 70.0093 129.821 70.2877 129.097 69.9006C128.373 69.5135 127.737 68.6034 127.669 67.8767C127.601 67.15 128.143 66.8715 128.867 67.2586Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.921 67.9239C129.28 68.1141 129.605 68.5759 129.632 68.9359C129.659 69.2958 129.395 69.4384 129.036 69.2483C128.677 69.0581 128.353 68.5963 128.326 68.2363C128.298 67.8764 128.562 67.7337 128.921 67.9239Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.379 59.8554C116.576 59.8283 116.819 59.8758 117.09 60.0184C117.814 60.4056 118.451 61.3157 118.518 62.0424C118.532 62.2257 118.518 62.3752 118.457 62.4974C118.247 63 117.273 63.2921 117.273 63.2921L115.202 60.5142C115.615 59.9777 116.312 59.8554 116.379 59.8486V59.8554Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.251 60.5156C116.975 60.9027 117.611 61.8128 117.679 62.5395C117.746 63.2662 117.205 63.5447 116.481 63.1576C115.757 62.7704 115.12 61.8603 115.053 61.1336C114.985 60.4069 115.526 60.1285 116.251 60.5156Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.305 61.1744C116.663 61.3646 116.988 61.8264 117.015 62.1863C117.042 62.5463 116.778 62.6889 116.42 62.4988C116.061 62.3086 115.736 61.8468 115.709 61.4868C115.682 61.1268 115.946 60.9842 116.305 61.1744Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.718 56.989C136.685 56.6222 136.928 56.1875 137.26 56.0177C137.395 55.943 137.531 55.9295 137.639 55.9702C137.754 55.9974 137.855 56.0925 137.855 56.0925H137.815C137.869 56.1672 137.903 56.2622 137.916 56.3709C137.95 56.7377 137.707 57.1723 137.375 57.3421C137.273 57.3965 137.179 57.4168 137.091 57.4101V57.4508C137.091 57.4508 136.935 57.3897 136.874 57.3286C136.786 57.2538 136.732 57.1452 136.718 56.9958V56.989Z",
    fill: "#BA7D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.732 57.9256L137.016 57.4094C136.908 57.3415 136.833 57.2193 136.813 57.0427C136.779 56.6759 137.023 56.2412 137.354 56.0714C137.686 55.9017 137.977 56.0579 138.011 56.4246C138.045 56.7914 137.801 57.226 137.469 57.3958C137.402 57.4298 137.334 57.4502 137.266 57.4638L136.935 58.0411C136.901 58.0954 136.813 58.1022 136.759 58.0546C136.718 58.0207 136.711 57.9731 136.732 57.9324V57.9256Z",
    fill: "#EEC1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.004 62.5443C117.93 61.7021 117.219 60.697 116.393 60.2487C116.136 60.1129 115.886 60.0382 115.656 60.0314C115.094 60.011 114.735 60.371 114.722 60.9415L112.596 59.8005L112.251 55.8273L116.183 57.9395L116.921 52.0239L124.786 56.2416L127.98 64.2626L134.532 67.7807L134.877 71.7539L130.627 69.4719C130.627 69.4175 130.627 69.3632 130.627 69.3021C130.552 68.4599 129.842 67.4547 129.016 67.0065C128.759 66.8706 128.508 66.7959 128.278 66.7891C127.717 66.7688 127.358 67.1355 127.344 67.706L118.024 62.7073C118.024 62.653 118.024 62.5986 118.024 62.5443H118.004Z",
    fill: "#D29985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.532 67.781L144.095 62.8163L144.441 66.7894L134.877 71.7542L134.532 67.781Z",
    fill: "#DBAC98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.544 59.3044L127.98 64.2692L134.532 67.7805L144.096 62.8158L137.544 59.3044Z",
    fill: "#EEC1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.544 59.3041L134.349 51.2831L124.779 56.241L127.98 64.2689L137.544 59.3041Z",
    fill: "#DBAC98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.165 59.1558L134.194 51.6985L125.158 56.3916L128.129 63.8489L137.165 59.1558Z",
    fill: "#806061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.349 51.2835L126.484 47.0658L116.921 52.0238L124.779 56.2414L134.349 51.2835Z",
    fill: "#EEC1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.251 55.8343L116.732 53.5048L116.183 57.9398L112.251 55.8343Z",
    fill: "#EEC1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.712 60.3717L116.502 58.1101L116.522 57.9538L116.895 54.9519L117.199 52.5137L120.17 54.1029L120.712 60.3717Z",
    fill: "#725457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.536 54.2999L124.515 56.4393L125.355 58.538L125.666 59.319L126.458 61.2954L126.654 63.557L124.908 62.6198L121.077 60.5687L120.536 54.2999Z",
    fill: "#725457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.821 65.3834L141.936 66.7078L137.151 69.1868L137.036 67.8624L141.821 65.3834Z",
    fill: "#BA7D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.693 66.8294L134.939 72.4122L134.823 71.0878L145.578 65.505L145.693 66.8294Z",
    fill: "#DBAC98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.938 72.4131L132.968 71.3604L132.853 70.036L134.823 71.0887L134.938 72.4131Z",
    fill: "#D29985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.578 65.5053L144.271 64.8058L144.326 65.4646L134.762 70.4293L133.449 69.723L132.853 70.0354L134.823 71.0881L145.578 65.5053Z",
    fill: "#EEC1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.205 68.4665L133.232 68.7314L132.704 68.4462L132.684 68.1813L133.205 68.4665Z",
    fill: "#EA9632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.205 68.4659L133.327 68.398L132.806 68.1195L132.684 68.1806L133.205 68.4659Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.232 68.7316L133.354 68.6705L133.327 68.3988L133.205 68.4667L133.232 68.7316Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.936 66.7095L141.659 66.5601L137.131 68.91L137.151 69.1885L141.936 66.7095Z",
    fill: "#D29985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.659 66.56L141.571 65.5141L141.821 65.385L141.936 66.7094L141.659 66.56Z",
    fill: "#C48C7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.229 58.4346L111.344 59.759L112.651 60.4653L112.536 59.1409L111.229 58.4346Z",
    fill: "#D29985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.65 60.4658L113.253 60.1534L113.138 58.829L112.535 59.1414L112.65 60.4658Z",
    fill: "#DBAC98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.229 58.4342L112.42 57.8162L112.481 58.475L113.138 58.8281L112.536 59.1406L111.229 58.4342Z",
    fill: "#EEC1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.248 61.5596L122.282 61.94L121.145 61.3355L121.111 60.9484L122.248 61.5596Z",
    fill: "#BA7D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.073 68.6967C135.039 68.33 135.283 67.8953 135.615 67.7255C135.75 67.6508 135.885 67.6372 135.994 67.678C136.109 67.7119 136.278 67.8274 136.278 67.8274L136.203 67.8478C136.237 67.9089 136.264 67.9836 136.271 68.0719C136.305 68.4386 136.061 68.8733 135.73 69.0431C135.642 69.0907 135.56 69.111 135.479 69.111L135.513 69.1586L135.499 69.1789C135.499 69.1789 135.296 69.1042 135.215 69.0159C135.134 68.9412 135.087 68.8326 135.073 68.6899V68.6967Z",
    fill: "#ADA1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.784 67.8208C136.115 67.651 136.407 67.8073 136.44 68.174C136.474 68.5408 136.231 68.9754 135.899 69.1452C135.567 69.315 135.276 69.1588 135.242 68.7921C135.209 68.4253 135.452 67.9906 135.784 67.8208Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.811 68.1198C135.994 68.0247 136.156 68.113 136.177 68.3168C136.197 68.5205 136.061 68.7582 135.879 68.8533C135.696 68.9484 135.534 68.8601 135.513 68.6563C135.493 68.4526 135.628 68.2149 135.811 68.1198Z",
    fill: "#C8CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.383 64.9078C142.35 64.541 142.593 64.1064 142.925 63.9366C143.06 63.8619 143.196 63.8483 143.304 63.889C143.419 63.923 143.588 64.0384 143.588 64.0384L143.514 64.0588C143.548 64.1199 143.575 64.1947 143.581 64.283C143.615 64.6497 143.372 65.0844 143.04 65.2542C142.952 65.3017 142.871 65.3221 142.789 65.3221L142.823 65.3696L142.81 65.39C142.81 65.39 142.607 65.3153 142.526 65.227C142.444 65.1523 142.397 65.0436 142.383 64.901V64.9078Z",
    fill: "#ADA1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.101 64.0318C143.433 63.862 143.724 64.0182 143.758 64.3849C143.792 64.7517 143.548 65.1864 143.216 65.3562C142.885 65.526 142.594 65.3697 142.56 65.003C142.526 64.6362 142.77 64.2016 143.101 64.0318Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.121 64.3235C143.304 64.2284 143.466 64.3167 143.487 64.5205C143.507 64.7242 143.372 64.962 143.189 65.057C143.006 65.1521 142.844 65.0638 142.823 64.8601C142.803 64.6563 142.938 64.4186 143.121 64.3235Z",
    fill: "#C8CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.548 64.0387L126.654 63.5564L126.458 61.2948L127.548 64.0387Z",
    fill: "#BA7D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.05 63.2498C125.016 62.8831 125.26 62.4484 125.591 62.2786C125.727 62.2039 125.862 62.1903 125.97 62.2311C126.085 62.2582 126.187 62.3533 126.187 62.3533H126.146C126.2 62.428 126.234 62.5231 126.248 62.6318C126.282 62.9985 126.038 63.4332 125.706 63.603C125.605 63.6573 125.51 63.6777 125.422 63.6709V63.7117C125.422 63.7117 125.266 63.6505 125.205 63.5894C125.117 63.5147 125.063 63.406 125.05 63.2566V63.2498Z",
    fill: "#BA7D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.686 62.3323C126.018 62.1625 126.309 62.3187 126.342 62.6855C126.356 62.8213 126.329 62.9707 126.275 63.1066L126.972 63.3035C127.019 63.3171 127.06 63.3579 127.06 63.4054C127.06 63.4733 126.999 63.5209 126.925 63.5005L126.173 63.2967C126.079 63.4462 125.95 63.5752 125.801 63.6499C125.469 63.8197 125.178 63.6635 125.144 63.2967C125.111 62.93 125.354 62.4953 125.686 62.3255V62.3323Z",
    fill: "#EEC1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.17 44.2896C172.367 44.2625 172.61 44.31 172.881 44.4526C173.605 44.8398 174.241 45.7499 174.309 46.4766C174.323 46.66 174.309 46.8094 174.248 46.9316C174.038 47.4342 173.064 47.7263 173.064 47.7263L170.993 44.9484C171.405 44.4119 172.103 44.2896 172.17 44.2828V44.2896Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.042 44.9421C172.766 45.3292 173.402 46.2393 173.47 46.966C173.531 47.6927 172.996 47.9712 172.272 47.5841C171.548 47.1969 170.911 46.2869 170.844 45.5601C170.776 44.8334 171.317 44.555 172.042 44.9421Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.096 45.6072C172.454 45.7974 172.779 46.2592 172.806 46.6192C172.833 46.9792 172.569 47.1218 172.211 46.9316C171.852 46.7415 171.527 46.2796 171.5 45.9197C171.473 45.5597 171.737 45.4171 172.096 45.6072Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.554 37.537C159.751 37.5098 159.994 37.5573 160.265 37.7C160.989 38.0871 161.625 38.9972 161.693 39.7239C161.707 39.9073 161.693 40.0567 161.632 40.1789C161.422 40.6815 160.448 40.9736 160.448 40.9736L158.377 38.1958C158.789 37.6592 159.487 37.537 159.554 37.5302V37.537Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.425 38.1962C160.149 38.5834 160.785 39.4935 160.853 40.2202C160.921 40.9469 160.379 41.2254 159.655 40.8382C158.931 40.4511 158.295 39.541 158.227 38.8143C158.159 38.0876 158.701 37.8091 159.425 38.1962Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.486 38.8549C159.845 39.0451 160.17 39.5069 160.197 39.8669C160.224 40.2269 159.96 40.3695 159.601 40.1793C159.243 39.9891 158.918 39.5273 158.891 39.1673C158.864 38.8074 159.128 38.6648 159.486 38.8549Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.426 33.5169L154.85 26.9017L160.096 29.7135L167.96 33.9312L171.155 41.9522L177.707 45.4703L178.052 49.4435L173.801 47.1615C173.801 47.1071 173.801 47.0528 173.801 46.9917C173.727 46.1495 173.016 45.1443 172.19 44.6961C171.933 44.5602 171.683 44.4855 171.453 44.4787C170.891 44.4583 170.532 44.8251 170.519 45.3956L161.199 40.3969C161.199 40.3426 161.199 40.2882 161.199 40.2339C161.124 39.3917 160.414 38.3865 159.588 37.9383C159.331 37.8025 159.08 37.7277 158.85 37.721C158.288 37.7006 157.93 38.0605 157.916 38.631L155.791 37.49L155.446 33.5169H155.426Z",
    fill: "#E06B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.893 34.6723C179.859 34.3056 180.102 33.8709 180.434 33.7011C180.569 33.6264 180.705 33.6128 180.813 33.6536C180.928 33.6807 181.03 33.7758 181.03 33.7758H180.989C181.043 33.8505 181.077 33.9456 181.091 34.0543C181.124 34.421 180.881 34.8557 180.549 35.0255C180.448 35.0798 180.353 35.1002 180.265 35.0934V35.1342C180.265 35.1342 180.109 35.073 180.048 35.0119C179.96 34.9372 179.906 34.8285 179.893 34.6791V34.6723Z",
    fill: "#C44845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.906 35.6089L180.191 35.0928C180.082 35.0248 180.008 34.9026 179.988 34.726C179.954 34.3593 180.197 33.9246 180.529 33.7548C180.861 33.585 181.152 33.7412 181.186 34.108C181.219 34.4747 180.976 34.9094 180.644 35.0792C180.576 35.1131 180.509 35.1335 180.441 35.1471L180.109 35.7244C180.076 35.7787 179.988 35.7855 179.933 35.738C179.893 35.704 179.886 35.6565 179.906 35.6157V35.6089Z",
    fill: "#FF978B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.707 45.4632L187.277 40.5052L187.622 44.4716L178.052 49.4364L177.707 45.4632Z",
    fill: "#F37A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.719 36.9871L171.155 41.9518L177.707 45.4631L187.277 40.5052L180.719 36.9871Z",
    fill: "#F7887F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.718 36.9877L177.524 28.9667L167.96 33.9314L171.155 41.9525L180.718 36.9877Z",
    fill: "#F37A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.346 36.8448L177.375 29.3875L168.332 34.0737L171.304 41.5311L180.346 36.8448Z",
    fill: "#806061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.71 31.9834L167.696 34.1228L168.529 36.2214L168.84 37.0025L169.632 38.9857L169.828 41.2405L168.082 40.3033L164.258 38.2522L163.71 31.9834Z",
    fill: "#725457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.996 43.0669L185.111 44.3913L180.333 46.8703L180.218 45.5527L184.996 43.0669Z",
    fill: "#C44845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.874 44.5127L178.113 50.0955L177.998 48.7779L188.759 43.1884L188.874 44.5127Z",
    fill: "#F37A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.113 50.0966L176.15 49.0439L176.035 47.7195L177.998 48.779L178.113 50.0966Z",
    fill: "#E06B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.759 43.1888L187.446 42.4893L187.507 43.1481L177.937 48.1128L176.631 47.4133L176.035 47.7189L177.998 48.7784L188.759 43.1888Z",
    fill: "#FF978B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.387 46.1505L176.407 46.4154L175.886 46.1301L175.859 45.8652L176.387 46.1505Z",
    fill: "#EA9632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.387 46.15L176.509 46.0888L175.988 45.8036L175.859 45.8647L176.387 46.15Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.407 46.4152L176.529 46.3539L176.509 46.0884L176.387 46.1497L176.407 46.4152Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.111 44.3919L184.834 44.2424L180.306 46.5924L180.333 46.8708L185.111 44.3919Z",
    fill: "#E06B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.833 44.2414L184.745 43.2022L184.996 43.0664L185.111 44.3908L184.833 44.2414Z",
    fill: "#F7887F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.404 36.1243L154.519 37.4419L155.832 38.1482L155.717 36.8238L154.404 36.1243Z",
    fill: "#E06B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.832 38.1491L156.428 37.8367L156.313 36.5123L155.717 36.8248L155.832 38.1491Z",
    fill: "#F37A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.404 36.1243L155.602 35.4995L155.656 36.1651L156.312 36.5115L155.717 36.8239L154.404 36.1243Z",
    fill: "#FF978B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.429 39.2426L165.456 39.6298L164.325 39.0185L164.292 38.6382L165.429 39.2426Z",
    fill: "#C44845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.248 46.3881C178.214 46.0214 178.458 45.5867 178.789 45.4169C178.925 45.3422 179.06 45.3286 179.169 45.3694C179.284 45.4033 179.453 45.5188 179.453 45.5188L179.378 45.5392C179.412 45.6003 179.439 45.675 179.446 45.7633C179.48 46.13 179.236 46.5647 178.905 46.7345C178.817 46.7821 178.735 46.8024 178.654 46.8024L178.688 46.85L178.674 46.8703C178.674 46.8703 178.471 46.7956 178.39 46.7073C178.309 46.6326 178.262 46.524 178.248 46.3813V46.3881Z",
    fill: "#ADA1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.966 45.5124C179.298 45.3426 179.589 45.4988 179.622 45.8655C179.656 46.2323 179.413 46.667 179.081 46.8368C178.749 47.0065 178.458 46.8503 178.424 46.4836C178.391 46.1168 178.634 45.6822 178.966 45.5124Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.986 45.804C179.169 45.7089 179.331 45.7972 179.351 46.001C179.372 46.2047 179.236 46.4424 179.054 46.5375C178.871 46.6326 178.708 46.5443 178.688 46.3405C178.668 46.1368 178.803 45.8991 178.986 45.804Z",
    fill: "#C8CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.564 42.5911C185.531 42.2244 185.774 41.7897 186.106 41.6199C186.241 41.5452 186.377 41.5316 186.485 41.5724C186.6 41.6063 186.769 41.7218 186.769 41.7218L186.695 41.7422C186.729 41.8033 186.756 41.878 186.762 41.9663C186.796 42.3331 186.553 42.7677 186.221 42.9375C186.133 42.9851 186.052 43.0054 185.97 43.0054L186.004 43.053L185.991 43.0734C185.991 43.0734 185.788 42.9986 185.707 42.9104C185.625 42.8356 185.578 42.727 185.564 42.5843V42.5911Z",
    fill: "#ADA1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.275 41.7151C186.607 41.5453 186.898 41.7015 186.932 42.0683C186.965 42.435 186.722 42.8697 186.39 43.0395C186.058 43.2093 185.767 43.0531 185.734 42.6863C185.7 42.3196 185.943 41.8849 186.275 41.7151Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.302 42.0068C186.485 41.9117 186.647 42 186.668 42.2037C186.688 42.4075 186.553 42.6452 186.37 42.7403C186.187 42.8354 186.025 42.7471 186.004 42.5433C185.984 42.3396 186.12 42.1018 186.302 42.0068Z",
    fill: "#C8CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.722 41.7227L169.828 41.2404L169.632 38.9856L170.722 41.7227Z",
    fill: "#C44845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.224 40.9327C168.19 40.5659 168.434 40.1313 168.766 39.9615C168.901 39.8868 169.036 39.8732 169.145 39.9139C169.26 39.9411 169.361 40.0362 169.361 40.0362H169.321C169.375 40.1109 169.409 40.206 169.422 40.3146C169.456 40.6814 169.212 41.1161 168.881 41.2859C168.779 41.3402 168.684 41.3606 168.596 41.3538V41.3945C168.596 41.3945 168.441 41.3334 168.38 41.2723C168.292 41.1976 168.238 41.0889 168.224 40.9395V40.9327Z",
    fill: "#C44845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.861 40.0162C169.192 39.8464 169.483 40.0026 169.517 40.3693C169.531 40.5052 169.504 40.6546 169.45 40.7904L170.147 40.9874C170.194 41.001 170.235 41.0417 170.235 41.0892C170.235 41.1572 170.174 41.2047 170.099 41.1843L169.348 40.9806C169.253 41.13 169.125 41.259 168.976 41.3337C168.644 41.5035 168.353 41.3473 168.319 40.9806C168.285 40.6138 168.529 40.1792 168.861 40.0094V40.0162Z",
    fill: "#FF978B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.85 26.902L164.421 21.9373L169.659 24.749L177.524 28.9667L167.96 33.9314L160.096 29.7138L154.85 26.902Z",
    fill: "#FF978B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.425 76.5757L104.345 87.1572L94.7817 92.1219L93.8612 81.5336L103.425 76.5757Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0566 87.0761C89.2529 87.049 89.4965 87.0965 89.7672 87.2391C90.4915 87.6263 91.1277 88.5364 91.1953 89.2631C91.2089 89.4464 91.1953 89.5959 91.1344 89.7181C90.9246 90.2207 89.95 90.5128 89.95 90.5128L87.8789 87.7349C88.2918 87.1984 88.9889 87.0761 89.0566 87.0693V87.0761Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9279 87.7273C89.6521 88.1144 90.2884 89.0245 90.356 89.7512C90.4237 90.4779 89.8823 90.7564 89.1581 90.3692C88.4339 89.9821 87.7976 89.072 87.73 88.3453C87.6623 87.6186 88.2037 87.3401 88.9279 87.7273Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9892 88.3924C89.3479 88.5826 89.6728 89.0444 89.6999 89.4044C89.727 89.7643 89.463 89.907 89.1043 89.7168C88.7456 89.5266 88.4207 89.0648 88.3936 88.7048C88.3666 88.3449 88.6305 88.2022 88.9892 88.3924Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4465 80.3193C76.6427 80.2921 76.8864 80.3397 77.1571 80.4823C77.8813 80.8694 78.5176 81.7795 78.5852 82.5062C78.5988 82.6896 78.5852 82.839 78.5243 82.9613C78.3145 83.4639 77.3399 83.7559 77.3399 83.7559L75.2688 80.9781C75.6817 80.4416 76.3788 80.3193 76.4465 80.3125V80.3193Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3177 80.9719C77.0419 81.359 77.6781 82.2691 77.7458 82.9958C77.8135 83.7225 77.272 84.001 76.5478 83.6139C75.8236 83.2267 75.1874 82.3166 75.1197 81.5899C75.052 80.8632 75.5935 80.5848 76.3177 80.9719Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3718 81.6369C76.7305 81.8271 77.0554 82.2889 77.0825 82.6489C77.1095 83.0088 76.8456 83.1515 76.4869 82.9613C76.1282 82.7711 75.8033 82.3093 75.7762 81.9493C75.7491 81.5894 76.0131 81.4467 76.3718 81.6369Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7079 79.7202L80.7519 74.511L93.8619 81.5404L94.7824 92.1287L90.6944 89.935C90.6944 89.8807 90.6944 89.8263 90.6944 89.772C90.62 88.9298 89.9093 87.9246 89.0836 87.4764C88.8264 87.3406 88.576 87.2658 88.3458 87.2591C87.7841 87.2387 87.4253 87.5986 87.4118 88.1691L78.092 83.1704C78.092 83.1161 78.092 83.0686 78.092 83.0142C78.0175 82.1721 77.3068 81.1669 76.4811 80.7186C76.2239 80.5828 75.9735 80.5081 75.7434 80.5013C75.1884 80.4809 74.8297 80.8409 74.8094 81.4046L72.5217 80.1753L72.1765 76.1953L78.7282 79.7202H78.7079Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1493 76.1947L81.7196 71.2367L84.3389 72.6426L80.7517 74.5035L78.7077 79.7196L72.1493 76.1947Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7212 91.4639L94.8363 92.7883L105.598 87.1987L105.483 85.8811L94.7212 91.4639Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.482 85.8802L104.169 85.1738L104.23 85.8394L94.6667 90.7974L94.0102 90.451L93.4078 90.7566L94.7209 91.463L105.482 85.8802Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4078 90.7577L93.5229 92.0821L94.8359 92.7884L94.7209 91.464L93.4078 90.7577Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9759 78.574L73.9962 78.8389L73.4751 78.5604L73.448 78.2955L73.9759 78.574Z",
    fill: "#EA9632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9763 78.5725L74.0913 78.5113L73.5702 78.2261L73.4484 78.294L73.9763 78.5725Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9966 78.8381L74.1187 78.7768L74.0916 78.5112L73.9762 78.5725L73.9966 78.8381Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9343 74.9127L84.3861 76.7465L85.0562 77.0997L85.6044 83.4228L84.9344 83.0628L84.4471 82.7979L80.2372 80.5431L79.9597 77.3849L80.9343 74.9127Z",
    fill: "#725457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6922 79.5509L73.8072 80.8753L73.2116 81.1877L73.0966 79.8633L73.6922 79.5509Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1271 78.8101L71.2421 80.1344L73.2117 81.1872L73.0966 79.8628L71.1271 78.8101Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6922 79.5513L73.0966 79.8637L71.1271 78.811L72.3251 78.1862L72.3792 78.8517L73.6922 79.5513Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6385 83.8019L85.6724 84.1823L84.5353 83.571L84.5015 83.1907L85.6385 83.8019Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8392 88.0748L96.9137 88.8966L95.7969 89.4739L95.7292 88.6521L96.8392 88.0748Z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3909 89.2556L95.3164 88.4338L95.7293 88.6512L95.7969 89.473L95.3909 89.2556Z",
    fill: "#A81D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8394 88.0738L96.4333 87.8497L95.3165 88.4338L95.7294 88.6511L96.8394 88.0738Z",
    fill: "#C92D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0406 88.4877L96.1083 89.3095L95.7969 89.4725L95.7292 88.6507L96.0406 88.4877Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0406 88.4875L95.6277 88.2701L95.3164 88.4331L95.7293 88.6505L96.0406 88.4875Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7293 88.6507L95.3164 88.4333L95.3909 89.2551L95.7969 89.4725L95.7293 88.6507Z",
    fill: "#EA9632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.642 84.5428L103.716 85.3646L102.6 85.9419L102.532 85.1201L103.642 84.5428Z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.194 85.7246L102.119 84.9028L102.532 85.1202L102.6 85.942L102.194 85.7246Z",
    fill: "#A81D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.642 84.5424L103.236 84.3251L102.119 84.9024L102.532 85.1197L103.642 84.5424Z",
    fill: "#C92D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.642 84.5428L103.716 85.3646L103.405 85.5276L103.331 84.7058L103.642 84.5428Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.642 84.5427L103.236 84.3253L102.924 84.4815L103.33 84.7057L103.642 84.5427Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9594 77.3837L78.9645 79.8491L80.2369 80.5418L79.9594 77.3837Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8632 79.5649L79.6145 79.7687C79.6889 79.789 79.7498 79.7415 79.7498 79.6736C79.7498 79.626 79.7092 79.5853 79.6618 79.5717L78.9647 79.3748L78.694 79.4155L78.8699 79.5717L78.8632 79.5649Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.74 79.5173C77.7061 79.1505 77.9498 78.7159 78.2814 78.5461C78.4168 78.4714 78.5521 78.4578 78.6604 78.4985C78.7755 78.5257 78.877 78.6208 78.877 78.6208H78.8364C78.8906 78.6955 78.9244 78.7906 78.9379 78.8992C78.9718 79.266 78.7281 79.7007 78.3965 79.8705C78.295 79.9248 78.2002 79.9452 78.1122 79.9384V79.9791C78.1122 79.9791 77.9565 79.918 77.8956 79.8569C77.8076 79.7822 77.7535 79.6735 77.74 79.5241V79.5173Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0325 78.9539C78.9986 78.5872 78.7076 78.431 78.376 78.6007C78.0443 78.7705 77.8074 79.212 77.8345 79.572C77.8616 79.9319 78.1594 80.0949 78.491 79.9251C78.8227 79.7553 79.0663 79.3139 79.0325 78.9539Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2137 79.9323C78.2882 79.9323 78.3694 79.9119 78.4506 79.8712C78.7552 79.715 78.9921 79.2871 78.965 78.9475C78.9447 78.7301 78.8296 78.5943 78.6537 78.5875C78.5792 78.5875 78.498 78.6079 78.4168 78.6487C78.1122 78.8049 77.8753 79.2327 77.9024 79.5723C77.9227 79.7897 78.0377 79.9255 78.2137 79.9323Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.425 76.5759L90.3151 69.5465L80.7516 74.5045L93.8617 81.5339L103.425 76.5759Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.666 54.3875C149.862 54.3604 150.106 54.4079 150.377 54.5505C151.101 54.9377 151.737 55.8478 151.805 56.5745C151.818 56.7579 151.805 56.9073 151.744 57.0295C151.534 57.5321 150.559 57.8242 150.559 57.8242L148.488 55.0463C148.901 54.5098 149.598 54.3875 149.666 54.3807V54.3875Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53 55.04C150.255 55.4271 150.891 56.3372 150.959 57.0639C151.026 57.7906 150.485 58.0691 149.761 57.682C149.036 57.2949 148.4 56.3848 148.332 55.658C148.265 54.9313 148.806 54.6529 149.53 55.04Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.592 55.6988C149.951 55.889 150.275 56.3508 150.303 56.7108C150.33 57.0707 150.066 57.2133 149.707 57.0232C149.348 56.833 149.023 56.3712 148.996 56.0112C148.969 55.6513 149.233 55.5086 149.592 55.6988Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.049 47.6237C137.245 47.5966 137.489 47.6441 137.76 47.7867C138.484 48.1739 139.12 49.084 139.188 49.8107C139.201 49.9941 139.188 50.1435 139.127 50.2657C138.917 50.7683 137.942 51.0604 137.942 51.0604L135.871 48.2825C136.284 47.746 136.981 47.6237 137.049 47.617V47.6237Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.92 48.284C137.644 48.6711 138.281 49.5812 138.348 50.308C138.416 51.0347 137.875 51.3131 137.15 50.926C136.426 50.5389 135.79 49.6288 135.722 48.9021C135.655 48.1754 136.196 47.8969 136.92 48.284Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.974 48.9428C137.333 49.133 137.658 49.5948 137.685 49.9548C137.712 50.3147 137.448 50.4574 137.09 50.2672C136.731 50.077 136.406 49.6152 136.379 49.2552C136.352 48.8953 136.616 48.7526 136.974 48.9428Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.31 47.0248L141.354 41.8156L145.97 44.2877L146.546 50.9029L155.04 55.4601L155.385 59.4333L151.297 57.2396C151.297 57.1852 151.297 57.1309 151.297 57.0766C151.222 56.2344 150.512 55.2292 149.686 54.781C149.429 54.6451 149.179 54.5704 148.948 54.5636C148.387 54.5432 148.028 54.9032 148.014 55.4737L138.694 50.475C138.694 50.4207 138.694 50.3731 138.694 50.3188C138.62 49.4766 137.909 48.4714 137.084 48.0232C136.826 47.8874 136.576 47.8126 136.346 47.8059C135.791 47.7855 135.432 48.1454 135.412 48.7092L133.124 47.4799L132.779 43.4999L139.331 47.0248H139.31Z",
    fill: "#E2AF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.603 50.5024L164.948 54.4688L155.384 59.4336L155.039 55.4604L164.603 50.5024Z",
    fill: "#F9CC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.752 43.5064L142.322 38.5485L144.942 39.9544L141.355 41.8153L139.31 47.0245L132.752 43.5064Z",
    fill: "#F7C961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.324 58.7753L155.439 60.0929L166.2 54.5101L166.085 53.1857L155.324 58.7753Z",
    fill: "#F9CC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.085 53.185L164.772 52.4855L164.833 53.1443L155.27 58.109L154.613 57.7559L154.018 58.0683L155.324 58.7746L166.085 53.185Z",
    fill: "#FCD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.018 58.0675L154.133 59.3919L155.439 60.0914L155.324 58.7738L154.018 58.0675Z",
    fill: "#E2AF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.579 45.8848L134.599 46.1497L134.078 45.8712L134.051 45.6063L134.579 45.8848Z",
    fill: "#EA9632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.579 45.8837L134.701 45.8226L134.18 45.5374L134.051 45.6053L134.579 45.8837Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.599 46.1489L134.721 46.0876L134.701 45.822L134.579 45.8833L134.599 46.1489Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.537 42.2227L144.989 44.0564L145.659 44.4096L146.207 50.7259L145.537 50.3727V50.3659L145.05 50.1078L140.84 47.8462L140.569 44.6948L141.537 42.2227Z",
    fill: "#725457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.295 46.8627L134.41 48.1871L133.814 48.4995L133.699 47.1751L134.295 46.8627Z",
    fill: "#F9CC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.73 46.1218L131.845 47.4394L133.814 48.4989L133.699 47.1745L131.73 46.1218Z",
    fill: "#E2AF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.295 46.8614L133.699 47.1738L131.73 46.1211L132.928 45.4962L132.989 46.1618L134.295 46.8614Z",
    fill: "#FCD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.241 51.1069L146.275 51.494L145.138 50.8828L145.104 50.5024L146.241 51.1069Z",
    fill: "#A86D16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.449 55.38L157.516 56.2086L156.4 56.7859L156.332 55.9641L157.449 55.38Z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.994 56.5685L155.919 55.7399L156.332 55.964L156.4 56.7858L155.994 56.5685Z",
    fill: "#A81D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.449 55.3797L157.036 55.1624L155.919 55.7396L156.332 55.9638L157.449 55.3797Z",
    fill: "#C92D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.643 55.7996L156.711 56.6214L156.399 56.7844L156.332 55.9626L156.643 55.7996Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.643 55.7991L156.231 55.5818L155.919 55.738L156.332 55.9621L156.643 55.7991Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.332 55.962L155.919 55.7379L155.994 56.5665L156.4 56.7838L156.332 55.962Z",
    fill: "#EA9632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.251 51.8546L164.319 52.6764L163.202 53.2537L163.135 52.4319L164.251 51.8546Z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.796 53.0354L162.722 52.2136L163.135 52.431L163.202 53.2528L162.796 53.0354Z",
    fill: "#A81D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.251 51.8536L163.839 51.6295L162.722 52.2136L163.135 52.4309L164.251 51.8536Z",
    fill: "#C92D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.251 51.8546L164.319 52.6764L164.008 52.8394L163.933 52.0108L164.251 51.8546Z",
    fill: "#F4A338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.251 51.8539L163.838 51.6298L163.527 51.7928L163.933 52.0101L164.251 51.8539Z",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.569 44.6954L139.567 47.154L140.84 47.8468L140.569 44.6954Z",
    fill: "#A86D16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.466 46.8757L140.217 47.0795C140.291 47.0998 140.352 47.0523 140.352 46.9844C140.352 46.9368 140.312 46.8961 140.264 46.8825L139.567 46.6855L139.297 46.7263L139.472 46.8825L139.466 46.8757Z",
    fill: "#FCD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.342 46.8284C138.309 46.4617 138.552 46.027 138.884 45.8572C139.019 45.7825 139.155 45.7689 139.263 45.8097C139.378 45.8369 139.479 45.9319 139.479 45.9319H139.439C139.493 46.0066 139.527 46.1017 139.54 46.2104C139.574 46.5772 139.331 47.0118 138.999 47.1816C138.897 47.236 138.803 47.2563 138.715 47.2495V47.2903C138.715 47.2903 138.559 47.2292 138.498 47.168C138.41 47.0933 138.356 46.9847 138.342 46.8352V46.8284Z",
    fill: "#A86D16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.635 46.2576C139.602 45.8909 139.311 45.7347 138.979 45.9045C138.647 46.0743 138.41 46.5157 138.437 46.8757C138.464 47.2356 138.762 47.3986 139.094 47.2288C139.426 47.0591 139.669 46.6176 139.635 46.2576Z",
    fill: "#FCD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.817 47.2432C138.891 47.2432 138.972 47.2228 139.054 47.1821C139.358 47.0259 139.595 46.598 139.568 46.2584C139.548 46.0411 139.433 45.9052 139.257 45.8984C139.182 45.8984 139.101 45.9188 139.02 45.9596C138.715 46.1158 138.478 46.5436 138.505 46.8832C138.526 47.1006 138.641 47.2364 138.817 47.2432Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.97 44.2947L155.534 39.3299L150.918 36.851L141.354 41.8157L145.97 44.2947Z",
    fill: "#FCD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.533 39.3291L156.109 45.9442L146.545 50.909L145.97 44.2939L155.533 39.3291Z",
    fill: "#F9CC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.783 45.7693L155.269 39.8062L146.294 44.4653L146.809 50.4284L155.783 45.7693Z",
    fill: "#806061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.603 50.5032L156.109 45.9459L146.545 50.9107L155.039 55.4611L164.603 50.5032Z",
    fill: "#F7F2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.109 45.9459L146.545 50.9107L155.039 55.4679L164.603 50.5032L156.109 45.9459ZM155.019 55.2302L148.697 51.8411L146.985 50.9243L156.129 46.1768L164.163 50.4828L162.586 51.3046L155.019 55.2302Z",
    fill: "#FCD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.129 46.1763L156.278 47.9014L148.698 51.8406L146.985 50.9237L156.129 46.1763Z",
    fill: "#F9CC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.278 47.9014L162.58 51.304L164.163 50.4822L156.129 46.1763L156.278 47.9014Z",
    fill: "#E2AF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.278 47.9009L162.579 51.3035L155.019 55.2292L148.698 51.8401L156.278 47.9009Z",
    fill: "#F4BD45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31281_77456",
    x1: 21.2721,
    y1: 72.7254,
    x2: 22.6359,
    y2: 72.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#764422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48270A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_31281_77456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.22507 0.270917 -0.244267 7.46755 19.977 64.0455)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53803B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31281_77456",
    x1: 40.0612,
    y1: 63.6919,
    x2: 41.4321,
    y2: 63.7368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#764422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48270A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_31281_77456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.22507 0.270917 -0.244267 7.46755 38.7698 55.0205)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53803B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_31281_77456",
    x1: 58.8597,
    y1: 54.661,
    x2: 60.2234,
    y2: 54.7056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#764422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48270A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_31281_77456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.22507 0.270915 -0.244268 7.46756 57.5606 45.9821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53803B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_31281_77456",
    x1: 77.6565,
    y1: 45.6291,
    x2: 79.0202,
    y2: 45.6737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#764422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48270A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_31281_77456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.22507 0.270915 -0.244268 7.46756 76.3567 36.946)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53803B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_31281_77456",
    x1: 96.4462,
    y1: 36.5973,
    x2: 97.8171,
    y2: 36.6421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#764422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48270A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_31281_77456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.22507 0.270915 -0.244268 7.46756 95.157 27.9113)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53803B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_31281_77456",
    x1: 115.242,
    y1: 27.5651,
    x2: 116.606,
    y2: 27.6097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#764422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48270A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_31281_77456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.22507 0.270917 -0.244267 7.46756 113.953 18.8799)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53803B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_31281_77456",
    x1: 134.04,
    y1: 18.5272,
    x2: 135.404,
    y2: 18.5718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#764422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48270A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_31281_77456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.22507 0.270919 -0.244265 7.46755 132.749 9.8421)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53803B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_31281_77456",
    x1: 152.836,
    y1: 9.49424,
    x2: 154.199,
    y2: 9.53885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#764422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48270A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_31281_77456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.22507 0.270915 -0.244268 7.46756 151.545 0.804258)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53803B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31281_77456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195.913,
    height: 107.71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingIcon);
export default __webpack_public_path__ + "static/media/parkingIcon.07424ba49fcff93c0a113cef9711cc79.svg";
export { ForwardRef as ReactComponent };